import type { FC } from "react";
import React, { useEffect } from "react";
import type { TrackEvent } from "src/state/Track/TrackCubit";
import { tracker } from "src/state/state";
import InDialog from "src/ui/components/InDialog/InDialog";
import useGoToOrBack from "src/ui/hooks/useGoToOrBack";
import { AppQueryPopupsController } from "../AppQueryPopupsBloc";
import MultiStepPharmacyInsuranceForm from "../../MultiStepPharmacyInsuranceForm/MultiStepPharmacyInsuranceForm";
import translate from "src/lib/translate";
import PatientPharmacyInsuranceBloc from "src/state/PatientPharmacyInsuranceBloc/PatientPharmacyInsuranceBloc";
import { useBlocNext } from "@blac/react";

const EnterPharmacyInsurance: FC<{
  returnUrl: string;
}> = ({ returnUrl }) => {
  const navigate = useGoToOrBack();
  const [, { checkIfPhotoUploadCanBeSkippedByUser, loadInsurances }] =
    useBlocNext(PatientPharmacyInsuranceBloc);

  useEffect(() => {
    void checkIfPhotoUploadCanBeSkippedByUser();
  }, []);

  const onClose = () => {
    AppQueryPopupsController.closePopup();
    navigate(returnUrl, {
      multiBack: true,
      replace: true
    });
  };

  const handleSaved = () => {
    tracker.track("Pharmacy Insurance Card Added/Updated" as TrackEvent);
    AppQueryPopupsController.closePopup();
    void loadInsurances();
  };

  return (
    <InDialog
      popup
      title={translate("pharmacyInsuranceCard")}
      onClose={onClose}
      returnUrl={returnUrl}
    >
      <MultiStepPharmacyInsuranceForm
        onInsuranceSaved={handleSaved}
        onCanceled={onClose}
      />
    </InDialog>
  );
};

export default EnterPharmacyInsurance;
